import useFlagVariation from './signalmizelyToSignalmanMapper';

export const catalogMat = Signalman.featureFlag('catalog_mat');
export const internalNewProductCard = Signalman.featureFlag(
  'pc_internal_new_product_card_v4'
);

export const pricingValuePropsPdpTest = Signalman.featureFlag(
  'pc_pdp_value_props_test_v4'
);

export const algoliaRecommendations = Signalman.featureFlag(
  'pc_algolia_recommendations_v1'
);

export const unitPriceDisplayTestFeatureFlag = Signalman.featureFlagFromCookie(
  'pc_unit_price_display_test_v4'
);

export const elevateDecoFilterTest = Signalman.featureFlag(
  'pc_elevate_deco_filter_v2'
);

export const unbundledPriceTest = Signalman.featureFlag(
  'pc_unbundled_price_v5'
);

export const comingSoonTest = Signalman.featureFlag('pc_coming_soon_v1');

export const pdpProductInfoLocationTest =
  Signalman.featureFlag('pc_pdp_info_loc_v3');

export const simplifiedRoutingTest = Signalman.featureFlag(
  'pc_simplified_routing_v0'
);

export const rushBadgesRemovalTest = Signalman.featureFlag(
  'pc_rush_badges_removal_v1'
);

// Temporary port over from Signalmizely

export const MOBILE_COLOR_SWATCHES_TEST_KEY =
  'pc_catalog_mobile_color_swatches_v3';

export function useSummerTShirtPromoTest() {
  return useFlagVariation('pc_sitewide_august_tshirts_promo');
}
export const elevatedProductInfoTest = Signalman.featureFlag(
  'pc_elevated_product_info_test_v1'
);

export const tshirtsCategoryRedesignTest = Signalman.featureFlag(
  'pc_tshirts_category_page_redesign'
);
